import React from 'react'

import dogpic from './images/logo1.jpg'

export const ProfileSocialFriendsCard = (props) => {
    return (
        <div className='brand-yellow-box-shadow'>
            <div className='row align-items-center justify-content-start'>
                <div className='col-md-2'>
                    <img src={dogpic} className='w-100 brand-yellow-border'
                     style={{borderRadius: "50%"}} alt="" />
                </div>
                <div className='col-md-6 align-items-start justify-content-center'>
                    <p className=''>{props.friend}</p>
                </div>
            </div>
        </div>
    )
}